(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-product-grid"]) return;
  try {
    
  const loadMoreContainers = document.querySelectorAll('[data-luxury-load-more]');

  for (const container of loadMoreContainers) {
    const btn = container.querySelector('[data-luxury-load-more-btn]');
    if (!btn) continue;

    const sectionId = container.dataset.sectionId;
    const grid = document.getElementById(`luxury-grid-${sectionId}`);
    const progressFill = container.querySelector('.luxury-load-more__progress-fill');
    const progressText = container.querySelector('.luxury-load-more__text');
    const totalProducts = parseInt(container.dataset.totalProducts, 10);
    const perPage = parseInt(container.dataset.perPage, 10);
    const totalPages = parseInt(container.dataset.totalPages, 10);
    let currentPage = parseInt(container.dataset.currentPage, 10);
    let nextUrl = container.dataset.nextUrl;
    let loading = false;

    btn.addEventListener('click', async () => {
      if (loading || !nextUrl) return;
      loading = true;
      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const separator = nextUrl.includes('?') ? '&' : '?';
        const fetchUrl = `${nextUrl}${separator}section_id=${sectionId}`;
        const response = await fetch(fetchUrl);
        const html = await response.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-luxury-grid]');

        if (newGrid) {
          const newCards = newGrid.children;
          const fragment = document.createDocumentFragment();
          while (newCards.length > 0) {
            fragment.appendChild(newCards[0]);
          }
          grid.appendChild(fragment);
        }

        currentPage++;
        const shownCount = Math.min(currentPage * perPage, totalProducts);
        const progressPercent = (currentPage / totalPages) * 100;

        if (progressFill) {
          progressFill.style.width = `${progressPercent}%`;
        }
        if (progressText) {
          progressText.textContent = `Showing ${shownCount} of ${totalProducts} products`;
        }

        const newLoadMore = doc.querySelector('[data-luxury-load-more]');
        if (newLoadMore && newLoadMore.dataset.nextUrl) {
          nextUrl = newLoadMore.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = 'Load More';
        } else {
          nextUrl = null;
          btn.remove();
        }
      } catch (error) {
        btn.disabled = false;
        btn.textContent = 'Load More';
      }

      loading = false;
    });
  }

  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-luxury-filter-toggle]');

    if (toggle) {
      const panelId = toggle.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      if (!panel) return;

      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      document.querySelectorAll('[data-luxury-filter-panel]').forEach((p) => {
        p.hidden = true;
        const t = document.querySelector(`[aria-controls="${p.id}"]`);
        if (t) t.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (!e.target.closest('[data-luxury-filter-panel]') && !e.target.closest('[data-luxury-filter-toggle]')) {
      document.querySelectorAll('[data-luxury-filter-panel]').forEach((p) => {
        p.hidden = true;
        const t = document.querySelector(`[aria-controls="${p.id}"]`);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-review-feed"] && !Shopify.designMode) return;
  try {
    
  class VideoReviewGrid extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.video-review-feed');

      this.cards = Array.from(this.querySelectorAll('[data-vrf-card]'));
      this.modal = root.querySelector('[data-vrf-modal]');
      this.reelsContainer = this.modal.querySelector('[data-vrf-reels]');
      this.reels = Array.from(this.modal.querySelectorAll('[data-vrf-reel]'));
      this.closeBtn = this.modal.querySelector('[data-vrf-close]');
      this.muteBtn = this.modal.querySelector('[data-vrf-mute]');
      this.prevBtn = this.modal.querySelector('[data-vrf-prev]');
      this.nextBtn = this.modal.querySelector('[data-vrf-next]');

      this.activeReelIndex = 0;
      this.modalMuted = false;

      this.handleClose = this.handleClose.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleMuteToggle = this.handleMuteToggle.bind(this);

      this.closeBtn.addEventListener('click', this.handleClose);
      this.muteBtn.addEventListener('click', this.handleMuteToggle);
      this.prevBtn.addEventListener('click', () => this.#goToReel(this.activeReelIndex - 1));
      this.nextBtn.addEventListener('click', () => this.#goToReel(this.activeReelIndex + 1));

      this.modal.addEventListener('close', () => this.#onModalClose());
      this.modal.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.handleClose();
      });

      for (const card of this.cards) {
        const index = this.cards.indexOf(card);
        const openTriggers = card.querySelectorAll('[data-vrf-open]');
        const soundBtn = card.querySelector('[data-vrf-sound]');

        for (const trigger of openTriggers) {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.#openModal(index);
          });
        }

        if (soundBtn) {
          soundBtn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.#toggleCardSound(card);
          });
        }
      }

      for (const reel of this.reels) {
        const playBtn = reel.querySelector('[data-vrf-reel-play]');
        if (playBtn) {
          playBtn.addEventListener('click', () => this.#toggleReelPlayback(reel));
        }
      }

      this.#initGridIntersection();
      this.#initReelIntersection();

      this.modalMuted = true;
      this.modal.classList.remove('is-unmuted');
    }

    /* ── Grid tile behavior ──────────────────────────────────────────────────── */

    #loadCardSrc(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video || video.src) return video;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const src = isMobile ? card.dataset.vrfMobileSrc : card.dataset.vrfSrc;

      if (src) video.src = src;
      return video;
    }

    #playCard(card) {
      const video = this.#loadCardSrc(card);
      if (!video) return;

      if (!card.classList.contains('is-unmuted')) video.muted = true;

      const promise = video.play();

      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => card.classList.add('is-playing'))
          .catch(() => card.classList.remove('is-playing'));
      }
    }

    #pauseCard(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (video && !video.paused) video.pause();
      card.classList.remove('is-playing');
    }

    #toggleCardPlayback(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return;

      if (video.paused) {
        this.#playCard(card);
      } else {
        this.#pauseCard(card);
      }
    }

    #toggleCardSound(card) {
      const video = card.querySelector('[data-vrf-video]');
      if (!video) return;

      const unmuting = !card.classList.contains('is-unmuted');

      if (unmuting) {
        for (const c of this.cards) {
          if (c === card) continue;
          c.classList.remove('is-unmuted');
          const v = c.querySelector('[data-vrf-video]');
          if (v) v.muted = true;
        }
      }

      video.muted = !unmuting;
      card.classList.toggle('is-unmuted', unmuting);
      const soundBtn = card.querySelector('[data-vrf-sound]');
      if (soundBtn) soundBtn.setAttribute('aria-pressed', String(unmuting));

      if (unmuting && video.paused) this.#playCard(card);
    }

    #initGridIntersection() {
      if (!('IntersectionObserver' in window)) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const card = entry.target;
            if (!card.querySelector('[data-vrf-video]')) continue;

            if (entry.isIntersecting) {
              this.#playCard(card);
            } else {
              this.#pauseCard(card);
              card.classList.remove('is-unmuted');
              const v = card.querySelector('[data-vrf-video]');
              if (v) v.muted = true;
            }
          }
        },
        { rootMargin: '160px 0px', threshold: 0.4 }
      );

      for (const card of this.cards) {
        if (card.querySelector('[data-vrf-video]')) observer.observe(card);
      }

      this.gridObserver = observer;
    }

    /* ── Modal reel behavior ─────────────────────────────────────────────────── */

    handleClose() {
      if (this.modal.open) this.modal.close();
    }

    handleKeydown(event) {
      if (!this.modal.open) return;

      if (event.key === 'ArrowDown' || event.key === 'PageDown') {
        event.preventDefault();
        this.#goToReel(this.activeReelIndex + 1);
      } else if (event.key === 'ArrowUp' || event.key === 'PageUp') {
        event.preventDefault();
        this.#goToReel(this.activeReelIndex - 1);
      } else if (event.key === 'm' || event.key === 'M') {
        this.handleMuteToggle();
      } else if (event.key === 'Escape') {
        this.handleClose();
      }
    }

    handleMuteToggle() {
      this.modalMuted = !this.modalMuted;
      this.modal.classList.toggle('is-unmuted', !this.modalMuted);
      this.muteBtn.setAttribute('aria-label', this.modalMuted ? 'Unmute' : 'Mute');

      for (const reel of this.reels) {
        const video = reel.querySelector('[data-vrf-reel-video]');
        if (video) video.muted = this.modalMuted;
      }
    }

    #openModal(index) {
      for (const c of this.cards) {
        const v = c.querySelector('[data-vrf-video]');
        if (v && !v.paused) v.pause();
        c.classList.remove('is-playing');
      }

      this.activeReelIndex = Math.max(0, Math.min(index, this.reels.length - 1));

      /* Audio ON when the modal opens — the click that opened it counts as a user gesture */
      this.modalMuted = false;
      this.modal.classList.add('is-unmuted');

      this.modal.showModal();

      requestAnimationFrame(() => {
        const target = this.reels[this.activeReelIndex];
        if (target) {
          this.reelsContainer.scrollTo({ top: target.offsetTop, behavior: 'instant' });
        }
        this.#updateNavState();
      });

      document.addEventListener('keydown', this.handleKeydown);
    }

    #onModalClose() {
      for (const reel of this.reels) {
        const video = reel.querySelector('[data-vrf-reel-video]');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
        }
        reel.classList.remove('is-playing');
      }

      this.modalMuted = true;
      this.modal.classList.remove('is-unmuted');

      document.removeEventListener('keydown', this.handleKeydown);
    }

    #goToReel(index) {
      const target = this.reels[index];
      if (!target) return;
      this.reelsContainer.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    }

    #updateNavState() {
      if (this.prevBtn) this.prevBtn.toggleAttribute('disabled', this.activeReelIndex <= 0);
      if (this.nextBtn) this.nextBtn.toggleAttribute('disabled', this.activeReelIndex >= this.reels.length - 1);
    }

    #loadReelSrc(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (!video || video.src) return video;

      const isMobile = window.matchMedia('(max-width: 699px)').matches;
      const src = isMobile ? reel.dataset.vrfMobileSrc : reel.dataset.vrfSrc;

      if (src) video.src = src;
      return video;
    }

    #playReel(reel) {
      const video = this.#loadReelSrc(reel);
      if (!video) return;

      video.muted = this.modalMuted;

      const promise = video.play();

      if (promise && typeof promise.then === 'function') {
        promise
          .then(() => reel.classList.add('is-playing'))
          .catch(() => {
            /* Autoplay with sound can be blocked — fall back to muted */
            if (!this.modalMuted) {
              this.modalMuted = true;
              this.modal.classList.remove('is-unmuted');
              video.muted = true;
              video.play().then(() => reel.classList.add('is-playing')).catch(() => reel.classList.remove('is-playing'));
            } else {
              reel.classList.remove('is-playing');
            }
          });
      }
    }

    #pauseReel(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (video && !video.paused) video.pause();
      reel.classList.remove('is-playing');
    }

    #toggleReelPlayback(reel) {
      const video = reel.querySelector('[data-vrf-reel-video]');
      if (!video) return;

      if (video.paused) {
        this.#playReel(reel);
      } else {
        this.#pauseReel(reel);
      }
    }

    #initReelIntersection() {
      if (!('IntersectionObserver' in window)) return;

      this.reelObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const reel = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              this.activeReelIndex = this.reels.indexOf(reel);
              this.#updateNavState();

              for (const other of this.reels) {
                if (other !== reel) this.#pauseReel(other);
              }

              this.#playReel(reel);
            }
          }
        },
        {
          root: this.reelsContainer,
          rootMargin: '0px',
          threshold: [0.6, 0.9]
        }
      );

      for (const reel of this.reels) {
        this.reelObserver.observe(reel);
      }
    }

    disconnectedCallback() {
      if (this.gridObserver) this.gridObserver.disconnect();
      if (this.reelObserver) this.reelObserver.disconnect();
      document.removeEventListener('keydown', this.handleKeydown);
    }
  }

  if (!customElements.get('video-review-grid')) {
    customElements.define('video-review-grid', VideoReviewGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
